// extracted by mini-css-extract-plugin
module.exports = {"tag":"ProductDropdown_tag__2ps66","closeTag":"ProductDropdown_closeTag__1YeSv","tagLabel":"ProductDropdown_tagLabel__i3VIS"};